module.exports = __webpack_public_path__ + "img/image-16.195da64f.png";